export class DateTableFilter {
  str: string = null;
  dateFilterCols: string[]|null = null;
  startFilterDate: Date|null = null;
  endFilterDate: Date|null = null;

  companiesFilter: string[] = null;
  productsFilter: string[] = null;
  cardStatusFilter: string[] = null;
  identStatusFilter: string[] = null;
  countriesFilter: string[] = null;

  sortField: string|null = null;
  sortDirection: string|null = null;

  someAdditionalData: string|null = null;
  additionalFilterData: string[] = null;
  enumFilter: { key: string; value: string } = null; // key=> typeof(enum), value:selected value from enum

  additionalField1: string|null = null;
  additionalField2: string|null = null;

  additionalValue1: string|null = null;
  additionalValue2: string|null = null;

  page: number;
  pageSize: number;
  numberFrom: number|null = null;
  numberTo: number|null = null;

}
